import { ErrorEffects } from './error.effects';
import {TransactionsEffects} from './transactions.effects';


export const AppEffects = [
    TransactionsEffects,
    ErrorEffects
];